export default "__VITE_ASSET__C3BhJ42K__"